/* tslint:disable */
/* eslint-disable */
/**
 * ELEMENTS API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 2
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    Job,
    JobFromJSON,
    JobFromJSONTyped,
    JobToJSON,
} from './';

/**
 * 
 * @export
 * @interface ImportJobResponse
 */
export interface ImportJobResponse {
    /**
     * 
     * @type {Array<Job>}
     * @memberof ImportJobResponse
     */
    jobs: Array<Job>;
}

export function ImportJobResponseFromJSON(json: any): ImportJobResponse {
    return ImportJobResponseFromJSONTyped(json, false);
}

export function ImportJobResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ImportJobResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'jobs': ((json['jobs'] as Array<any>).map(JobFromJSON)),
    };
}

export function ImportJobResponseToJSON(value?: ImportJobResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'jobs': ((value.jobs as Array<any>).map(JobToJSON)),
    };
}


